module.exports = __webpack_public_path__ + "static/logo3-820f37b94e948aeccb51833a1091627c.jpg";